'use client';

import { useEffect } from 'react';
import { captureUtms } from '@/util/utm_client';

/**
 * Captures all 5 standard UTM params from URL into _utm_* cookies.
 * Renders nothing — purely a side-effect component.
 */
export default function UtmSourceCapture() {
  useEffect(() => {
    captureUtms();
  }, []);

  return null;
}
